/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Spacer, theme } from "@nordcloud/gnui";
import { FilterHeader, Mode, getSelectedMode } from "~/components";
import { isNotEmpty, noop } from "~/tools";
import { MultiTagsInput } from "./MultiTagsInput";

type Props = {
  inputTags?: string[];
  onChange: (tags: string[]) => void;
  placeholderName: string;
  isExcludeSelected?: boolean;
  onModeChange?: (mode: Mode) => void;
};

export function EstateMultiTagsInput({
  inputTags,
  onChange,
  placeholderName,
  isExcludeSelected,
  onModeChange,
}: Props) {
  return (
    <>
      <FilterHeader
        allowModeChange
        defaultMode={getSelectedMode(isExcludeSelected)}
        onSetSearch={noop}
        onModeChange={onModeChange}
      />
      <Spacer height={theme.spacing.spacing04} />
      <MultiTagsInput
        showIcon
        inputTags={isNotEmpty(inputTags ?? []) ? inputTags : [""]}
        width="14rem"
        placeholder={{
          key: `${placeholderName} Key`,
          value: `${placeholderName} Value`,
        }}
        onChange={onChange}
      />
    </>
  );
}
